/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Adapptio Shared library.
 *
 * @package lib-shared
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import lodashCloneDeep from "lodash.clonedeep";

export function cloneDeepWithDataLoss(data: any): any {
	return JSON.parse(JSON.stringify(data));
}

export function cloneDeep(data: any): any {
	return lodashCloneDeep(data);
}
